export enum RefValidState {
    invalid='invalid', unknown='unknown', valid='valid'
}
